interface Params {
  assetAllocation: { color: string | null; color_group: number }[];
}

export const getAssetAllocationColors = ({ assetAllocation }: Params) => {
  const colorGroups = ADV.settings.color_groups as string[][];

  const nextColor = colorGroups.map(() => 0);

  return assetAllocation.map(({ color, color_group: colorGroup }) => {
    const assetClassColor = color || colorGroups[colorGroup][nextColor[colorGroup]];

    if (!assetClassColor) {
      return colorGroups[3][nextColor[colorGroup] % colorGroups[colorGroup].length];
    }

    nextColor[colorGroup] += 1;

    return assetClassColor;
  });
};
